<template>
    <div class="wrapper">
        <p class="title">Habitación <slot></slot></p>
        <div class="elements">
            <label>Adultos</label>
            <input type="number" v-model="adults" min="1" max="9">

            <label>Niños</label>
            <input type="number" v-model="children" max="9" min="0">
        </div>
    </div>
</template>

<script>
    export default {
        name: "RoomDistribution",
        data() {
            return {
                adults: 1,
                children: 0
            }
        }
    }
</script>

<style scoped>
    .title {
        padding: 0;
        margin: 0 0 5px 0;
        text-align: center;
        font-size: 18px;
        color: #643229;
    }
    .wrapper {
        flex-direction: row;
        justify-content: space-evenly;
        margin-bottom: 20px;
    }

    .wrapper .elements {

    }

    .wrapper input {
        width: 100px;
        padding: 5px 5px 0 5px;
        font-size: 16px;
        border: 0;
        border-bottom: 1px solid #666;
        text-align: center;
    }

    @media only screen and (min-width: 320px) and (max-width: 767px) {
        .wrapper .elements {
            display: flex;
            justify-content: center;
            align-items: baseline;
        }
    }

</style>